export default "assets/images/icons/arrow-fa5fc60e.svg";